import { removeUndefinedValues } from "../utils/remove-values"
import BaseApi from "./base"
import { getQueryString } from "./base"

class SectionsApi extends BaseApi {
  async loadMoreTasks(projectId, sectionId, pageParam, filters) {
    const query = getQueryString(
      this.paramsToSnakeCase({
        per_page: 10,
        page: pageParam,
        q: { s: ["project_section_position ASC"] },
        filters: filters,
      }),
      true
    )

    const response = this.get(
      `/projects/${projectId}/project_sections/${sectionId}/tasks/project_section_list${query}`
    )

    console.log(query)

    return this.getResponseJson(response)
  }

  async createSection(id: string, name: string) {
    const body = { name: name }
    return this.post(`/projects/${id}/project_sections`, body)
  }

  async updateSection(
    projectId: string,
    id: string,
    name: string,
    status: "active" | "archived"
  ) {
    const body = { name: name, status: status }
    return this.patch(`/projects/${projectId}/project_sections/${id}`, body)
  }

  async updateProjectSection(params: {
    projectId: string,
    projectSectionId: string,
    name?: string,
    status?: "active" | "archived"
  }) {
    const {
      projectId,
      projectSectionId,
      name,
      status,
    } = params

    const body = removeUndefinedValues({ name: name, status: status })
    return this.patch(`/projects/${projectId}/project_sections/${projectSectionId}`, body)
  }

  async deleteProjectSection(projectId: string, id: string) {
    return this.delete(`/projects/${projectId}/project_sections/${id}`)
  }

  async reorderSection(projectId: string, id: string, position: number) {
    const body = { position: position }
    return this.patch(
      `/projects/${projectId}/project_sections/${id}/reorder`,
      body
    )
  }
}

export default SectionsApi
